import { Injectable } from '@angular/core';
import { RestApiService } from './rest-api.service';
import { User } from '../interfaces/user';

@Injectable({
    providedIn: 'root'
})
export class UsersService {

    public users: Array<User> = [];
    public count: number = 0;
    public maxPages: number = 1;
    public pageSize: number = 8;

    constructor(
        private api: RestApiService
    ) { }

    getUser(id): Promise<any> {
        return new Promise((resolve, reject) => {
            this.api.get('/MI_Galago/WCF_MI_Galago/REST/vop/user/' + id, {}, true).then((res) => {
                resolve(res);
            });
        });
    }

    getUserDrivingLicense(id): Promise<any> {
        return new Promise((resolve, reject) => {
            this.api.get(`/MI_Galago/WCF_MI_Galago/REST/vop/account/${id}/driving-license`, {}, true).then((res) => {
                resolve(res);
            });
        });
    }

    getUserIDCard(id): Promise<any> {
        return new Promise((resolve, reject) => {
            this.api.get(`/MI_Galago/WCF_MI_Galago/REST/vop/account/${id}/identity-card`, {}, true).then((res) => {
                resolve(res);
            })
        });
    }

    updateUserCount(search?: string, idSocietyVop?: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let query: any = {};

            if (typeof search === 'string' && search.length > 0) {
                query.search = search;
            }
            if (idSocietyVop && idSocietyVop > 0) {
                query.id_society_vop = idSocietyVop;
            }
            this.api.get('/MI_Galago/WCF_MI_Galago/REST/GetSocietyVopUsersCount', query, true).then((res) => {
                this.count = res;
                this.maxPages = Math.ceil(res / this.pageSize);
                if (res <= this.pageSize) {
                    this.maxPages = 0;
                }
                resolve(res);
            });
        });
    }

    getUsers(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.api.get('/MI_Galago/WCF_MI_Galago/REST/getSocietyVopUsers', {}, false).then((res) => {
                if (typeof res === 'object' && res.length > 0) {
                    this.users = res;
                }
                resolve(res);
            });
        });
    };

    updateUser(updatedUser): Promise<any> {
        return new Promise((resolve, reject) => {
            this.api.put('/MI_Galago/WCF_MI_Galago/REST/vop/user', {
                user: updatedUser
            }, false).then((res) => {
                resolve(res);
            });
        });
    };

    updateUsers(page, search?: string, idSocietyVop?: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let query: any = {
                page: page,
                pageSize: this.pageSize,
                column: 4,
                sortType: 1
            };

            if (typeof search === 'string' && search.length > 0) {
                query.search = search;
            }
            if (idSocietyVop && idSocietyVop > 0) {
                query.id_society_vop = idSocietyVop;
            }

            this.api.get('/MI_Galago/WCF_MI_Galago/REST/GetSocietyVopUsers', query, true).then((res) => {
                if (typeof res === 'object' && res.length > 0) {
                    this.users = res;
                }
                resolve(res);
            });
        });
    }

    updateDocument(id: number, field: number, photo: any): Promise<any> {
        return new Promise((resolve, reject) => {
            let formData = new FormData();

            formData.append('id_account', id.toString());
            formData.append('field', field.toString());
            formData.append('file', photo);
            this.api.put('/MI_Galago/WCF_MI_Galago/REST/vop/account/document', formData, false).then((res) => {
                resolve(res);
            });
        });
    }

    activateUser(id: number, activate: boolean) {
        return new Promise((resolve, reject) =>  {
            let action : string = (activate === true) ? 'enable' : 'disable';

            this.api.put(`/MI_Galago/WCF_MI_Galago/REST/vop/account/${id}/activation/${action}`, {}, false).then((res) => {
                resolve(res);
            });
        });
    }

    registerUser(user: any, photos: any, idSocietyVop: number, societyCode: string = '') {
        return new Promise((resolve, reject) => {
            let formData = new FormData();

            formData.append('mail_address', user.email);
            formData.append('password', user.password);
            formData.append('gender', user.gender);
            formData.append('lastname', user.lastName);
            formData.append('firstname', user.firstName);
            formData.append('mobile', user.mobile);
            formData.append('code_society', societyCode);
            formData.append('id_society_vop', idSocietyVop.toString());
            formData.append('age', user.age);
            formData.append('driving_license_front', photos.drivingLicenseFront);
            formData.append('driving_license_back', photos.drivingLicenseBack);
            formData.append('identity_card_front', photos.identityCardFront);
            formData.append('identity_card_back', photos.identityCardBack);
            this.api.vpost('/MI_Galago/WCF_MI_GALAGO_STATIC/CreateAccountVOP', formData, false).then((res) => {
                resolve(res);
            });
        });
    }
}
